// this is an autogenerated file from App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Ledger/New/Treatments/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Patients_Content_Content_Sections_ActiveTab_Ledger_New_Treatments($patient_id: uuid!) {
  vaxiom_txs(
    where: { patient_id: { _eq: $patient_id }, deleted: { _eq: false } }
    order_by: {
      tx_card: { latest_appointment_booking_start_time: desc_nulls_last }
    }
  ) {
    id
    _id
    name
    status
    is_active
    tx_status_name {
      id
      name
    }
  }
}

`